import AccountPayableListModal from '@/components/_common/AccountPayableListModal';
import { InstallmentSituation } from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { useDisclosure } from '@/hooks';
import moment from 'moment';
import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import { DateTimeFormat } from '@/utils/moment';
import DashboardStatisticCard from '../../DashboardStatisticCard';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  value?: number;
}
function PayToday({ value }: Props) {
  const [viewAccountPayablesOpen, viewAccountPayablesActions] = useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Valor de parcelas do contas a pagar com data de vencimento igual ao dia atual."
        statisticTitle="Parcelas a pagar | Dia"
        color={StatisticDashboardTypeColor.expense}
        value={formatterPrice(value || 0)}
        module={StatisticDashboardModule.accountPayable}
        onClick={viewAccountPayablesActions.open}
      />

      <AccountPayableListModal
        open={viewAccountPayablesOpen}
        onCancel={viewAccountPayablesActions.close}
        queryFilter={{
          situation: InstallmentSituation.open,
          dueDate: moment().format(DateTimeFormat),
        }}
      />
    </>
  );
}

export default PayToday;
